import { NotifyPasswordChangedResponse } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type NotifyPasswordChangedOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
};

export const notifyPasswordChanged = async <TFunctions>(
  options: NotifyPasswordChangedOptions<TFunctions>,
): Promise<NotifyPasswordChangedResponse> => {
  const { functions, httpsCallable } = options;
  const callable = httpsCallable<
    Record<string, never>,
    NotifyPasswordChangedResponse
  >(functions, 'users-notifyPasswordChanged');

  return (await callable({})).data;
};
